import { render, staticRenderFns } from "./NewOffering.vue?vue&type=template&id=a47471fe&scoped=true"
import script from "./NewOffering.vue?vue&type=script&lang=js"
export * from "./NewOffering.vue?vue&type=script&lang=js"
import style0 from "./NewOffering.vue?vue&type=style&index=0&id=a47471fe&prod&scoped=true&lang=css"
import style1 from "./NewOffering.vue?vue&type=style&index=1&id=a47471fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47471fe",
  null
  
)

export default component.exports